import { render, staticRenderFns } from "./question_reply_item.vue?vue&type=template&id=28a684d8&scoped=true&"
import script from "./question_reply_item.vue?vue&type=script&lang=js&"
export * from "./question_reply_item.vue?vue&type=script&lang=js&"
import style0 from "./question_reply_item.vue?vue&type=style&index=0&id=28a684d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a684d8",
  null
  
)

export default component.exports